/* ==========================================================================
   <cheo-policy-modal> — modal de política (Calzado Cheo)

   Mismo comportamiento que la guía de tallas: modal en desktop, hoja inferior
   en móvil, de consulta y sin botones de acción. Se usa para el texto de la
   política de envíos que abre la tarjeta de garantía de la ficha.

   Es un <dialog> nativo, así que el atrapado de foco, la devolución del foco al
   disparador y el cierre con Esc los da el navegador. Aquí solo se añade el
   cierre por clic en el fondo.

   El disparador se escucha delegado en el documento para que siga funcionando
   cuando el editor de temas reemplaza el bloque que lo contiene.
   ========================================================================== */

class CheoPolicyModal extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;

    this.dialog.addEventListener('click', (event) => {
      /* Clic en el fondo: el <dialog> ocupa toda la ventana, el panel es su hijo. */
      if (event.target === this.dialog) this.close();
    });

    this.querySelector('[data-policy-modal-close]')?.addEventListener('click', () => this.close());
  }

  open() {
    this.dialog?.showModal();
  }

  close() {
    this.dialog?.close();
  }
}

if (!customElements.get('cheo-policy-modal')) {
  customElements.define('cheo-policy-modal', CheoPolicyModal);
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-policy-modal-open]');
  if (!trigger) return;

  const modal = document.getElementById(trigger.dataset.policyModalOpen);
  if (!modal?.open) return;

  event.preventDefault();
  modal.open();
});
